import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.supplier.TermsAndConditionsModal.';

  public static readonly termsAndConditionsFor = `${Id.prefix}termsAndConditionsFor`;
  public static readonly accept = `${Id.prefix}accept`;
  public static readonly mustAcceptTerms = `${Id.prefix}mustAcceptTerms`;
}

export class LangSupplierTermsAndConditionsModal {
  private constructor() {}

  public static termsAndConditionsFor(params: { supplier: string }): string {
    return interpolate(Id.termsAndConditionsFor, params);
  }
  public static accept(): string {
    return interpolate(Id.accept);
  }
  public static mustAcceptTerms(): string {
    return interpolate(Id.mustAcceptTerms);
  }
}

export class SupplierTermsAndConditionsModalModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.termsAndConditionsFor,
      'Terms and Conditions for {{supplier}}',
      'Dialog title for supplier terms and conditions, with supplier name'
    );
    register.add(Id.accept, 'Accept', 'Button label for accepting terms and conditions');
    register.add(
      Id.mustAcceptTerms,
      'The following terms must be accepted to use this software',
      'Heading for terms acceptance'
    );
  }
}
